import AbstractCommand from "../../../core/application/AbstractCommand";
import ConversationEndedEvent from "../../conversation/event/ConversationEndedEvent";
import Conversation from "../../conversation/model/Conversation";
import PlatformUserTrackingService from "./PlatformUserTrackingService";

export default class TrackPlatformConversationEnded extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {PlatformUserTrackingService} platformUserTrackingService 
     */
    constructor(dispatcher, platformUserTrackingService) {
        super(dispatcher);

        this._platformUserTrackingService = platformUserTrackingService;
    }

    execute(evt) {
        /** @type {ConversationEndedEvent} */
        const conversationEndedEvent = evt.params.data;
        const { conversation } = conversationEndedEvent;

        this._trackConversationEnded(conversation);
    }

    /**
     * @param {Conversation} conversation 
     */
    async _trackConversationEnded(conversation) {
        console.log(`[${TrackPlatformConversationEnded.name}] Tracking conversation ended for conversationId: '${conversation.id}'.`);
        await this._platformUserTrackingService.reportConversationResult({
            conversationId: conversation.id,
            summary: conversation.feedbackSummary,
            feedbackItems: conversation.feedback.map(feedback => ({
                quote: feedback.quote,
                feedback: feedback.feedback,
            })),
        });
    }
}
